import React from "react";
import { ChevronDown } from "lucide-react";

const learningBackgroundOptions = [
  {
    value: "formal",
    label: "Kursus formal",
    description: "LBI, EF, Wall Street, kursus bersertifikat",
  },
  {
    value: "informal",
    label: "Kursus informal / bimbel",
    description: "Kelas privat, komunitas, bimbingan non-sertifikat",
  },
  {
    value: "self_study",
    label: "Belajar mandiri",
    description: "YouTube, aplikasi, buku, podcast",
  },
  {
    value: "none",
    label: "Belum pernah belajar intensif",
    description: "Hanya dari pelajaran sekolah",
  },
];

const durationOptions = [
  { value: "0", label: "Belum pernah belajar" },
  { value: "1", label: "Kurang dari 1 bulan" },
  { value: "3", label: "1-3 bulan" },
  { value: "6", label: "4-6 bulan" },
  { value: "12", label: "7-12 bulan" },
  { value: "24", label: "Lebih dari 2 tahun" },
];

const Step3 = ({ currentStep, totalSteps, answers, setAnswers, onBack, onNext }) => {
  const canContinue = Boolean(answers.learningBackground && answers.learningDurationMonths !== "");

  return (
    <>
      <p className="st-font-body st-text-body-muted text-[14px] sm:text-[15px]">
        Step {currentStep} of {totalSteps}
      </p>

      <h1 className="st-font-body mt-1.5 text-[28px] font-bold leading-[1.15] text-[#212121] sm:text-[34px]">
        <span className="mr-2 inline-block h-2 w-2 rounded-full bg-[#BB230B] align-middle" />
        Latar belakang belajar
      </h1>
      <p className="st-font-body st-text-body-muted mt-1.5 text-[16px] sm:text-[18px]">
        Bagaimana riwayat belajar bahasa Inggris kamu sebelumnya?
      </p>

      <div className="mt-4 space-y-5">
        <div>
          <h2 className="st-font-body text-[22px] font-bold leading-[1.2] text-[#282828] sm:text-[24px]">
            Tipe belajar bahasa Inggris yang sudah/pernah kamu lakukan
          </h2>

          <div className="mt-2 space-y-2">
            {learningBackgroundOptions.map((item) => (
              <button
                key={item.value}
                type="button"
                onClick={() =>
                  setAnswers((prev) => ({
                    ...prev,
                    learningBackground: item.value,
                  }))
                }
                className={`st-focus-ring st-font-body st-readiness-option items-start py-2.5 ${
                  answers.learningBackground === item.value ? "st-readiness-option-active" : ""
                }`}
              >
                <span className="st-readiness-radio mt-1" aria-hidden="true" />
                <span className="flex flex-col text-left">
                  <span>{item.label}</span>
                  <span className="mt-0.5 text-[12px] leading-[1.25] text-[#5D5D5D] sm:text-[13px]">{item.description}</span>
                </span>
              </button>
            ))}
          </div>
        </div>

        <div>
          <h2 className="st-font-body text-[22px] font-bold leading-[1.2] text-[#282828] sm:text-[24px]">Sudah berapa bulan belajar?</h2>
          <div className="relative mt-2">
            <select
              value={answers.learningDurationMonths}
              onChange={(event) =>
                setAnswers((prev) => ({
                  ...prev,
                  learningDurationMonths: event.target.value,
                }))
              }
              className="st-focus-ring st-font-body st-readiness-select appearance-none"
            >
              <option value="">-- Pilih --</option>
              {durationOptions.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
            <ChevronDown size={20} className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-[#555]" />
          </div>
        </div>
      </div>

      <div className="mt-5 flex justify-between">
        <button type="button" className="st-focus-ring st-readiness-next" onClick={onBack}>
          ← Back
        </button>

        <button type="button" disabled={!canContinue} className="st-focus-ring st-readiness-next" onClick={onNext}>
          Next →
        </button>
      </div>
    </>
  );
};

export default Step3;
